import { observer } from 'mobx-react';

import { UserDashboardWidgetModel } from "shared/models";

import { PPDWidgetBase } from "./components/PPDWidgetBase";
import { PPDWidgetGrid } from "./components/PPDWidgetGrid";
import { PPDWidgetCompare } from "./components/PPDWidgetCompare";
import { PPDWidgetProgress } from './components/PPDWidgetProgress';
import { PPDWidgetLeagueStatus } from './components/PPDWidgetLeagueStatus';
import { PPDWidgetLineChart } from './components/PPDWidgetLineChart';
import { PPDWidgetLeagueRating } from './components/PPDWidgetLeagueRating';
import { PPDWidgetProductGroupsPrices } from './components/PPDWidgetProductGroupsPrices';
import { PPDWidgetPieChart } from './components/PPDWidgetPieChart';

import './styles.scss';

type PropsType = {
    indexWidget?: number;
    widget: UserDashboardWidgetModel,
    className?: string,
    onOpenLeagueInfo?: () => void;
}

export const PPDWidget = observer(({ widget, indexWidget, onOpenLeagueInfo }: PropsType) => {
    if (widget.type_id  === 'base') {
        return <PPDWidgetBase widget={widget}/>;
    }

    if (widget.type_id === 'compare') {
        return <PPDWidgetCompare widget={widget}/>;
    }

    if (widget.type_id === 'grid') {
        return <PPDWidgetGrid widget={widget} indexWidget={indexWidget}/>
    }

    if (widget.type_id === 'progress') {
        return <PPDWidgetProgress widget={widget}/>;
    }

    if (widget.type_id === 'league_status') {
        return <PPDWidgetLeagueStatus widget={widget} onOpenLeagueInfo={onOpenLeagueInfo}/>;
    }

    if (widget.type_id === 'line_chart') {
        return <PPDWidgetLineChart widget={widget}/>;
    }
    if (widget.type_id === 'league_rating') {
        return <PPDWidgetLeagueRating widget={widget} onOpenLeagueInfo={onOpenLeagueInfo}/>
    }

    if (widget.type_id === 'product_groups_prices') {
        return <PPDWidgetProductGroupsPrices widget={widget}/>
    }

    if (widget.type_id === 'pie_chart') {
        return <PPDWidgetPieChart widget={widget}/>
    }

    return null;
});
